module.exports = __webpack_public_path__ + "static/image/service/bmart.ver2_0_2.jpg?7f6d475b";